import EmptyPage from 'components/empty-page';
import { FunctionComponent } from 'react';

interface MapPageProps {}

const MapPage: FunctionComponent<MapPageProps> = () => {
  return <EmptyPage title='Žemėlapis' />;
};

export default MapPage;
